import { Routes } from '@angular/router';
import { integrationListRoutes } from './routes/integration-list.routes';

export const routes: Routes = [
  {
    path: 'agent-integrations/list',
    loadComponent: () =>
      import('./components/list/list.component').then(
        (m) => m.ListComponent
      ),
    // children: integrationListRoutes
  },
  {
    path: 'agent-integrations/integration',
    loadComponent: () =>
      import('./components/list/components/configure-tool/configure-tool.component').then(
        (m) => m.ConfigureToolComponent
      ),
    children: integrationListRoutes
  },
  {
    path: '',
    redirectTo: 'agent-integrations/list',
    pathMatch: 'full'
  }
];
